exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1Qiy-Hk5-Map-module-label{font-size:20px;height:135px;width:300px;background-color:#fff;box-shadow:0 2px 7px 1px rgba(0,0,0,.3);padding:5px;opacity:1!important}", ""]);

// exports
exports.locals = {
	"label": "_1Qiy-Hk5-Map-module-label"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"localIdentName":"[hash:base64:8]-[name]-[local]","modules":true,"camelCase":true}!../~/postcss-loader/lib!../~/sass-loader/lib/loader.js!./js/components/support/maps/Map.module.scss
// module id = 762
// module chunks = 0